const FULL_HEIGHT_CONTENT_ROUTE = /\/(mosaic|patrol)(-view|\/view)\//;

export function isFullHeightContentUrl(url: string): boolean {
  return FULL_HEIGHT_CONTENT_ROUTE.test(url);
}
